import React from "react";

export function ContractIcon(props) {
  const { height = "24", width = "24", color = "#EBEBEB" } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 22a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 3 19v-3h3V2h15v17c0 .833-.292 1.542-.875 2.125A2.893 2.893 0 0 1 18 22H6zm12-2c.283 0 .52-.096.712-.288A.968.968 0 0 0 19 19V4H8v12h9v3c0 .283.096.52.288.712.191.192.429.288.712.288zM9 9V7h9v2H9zm0 3v-2h9v2H9z"
        fill={color}
      />
    </svg>
  );
}
